import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookies are the auth mechanism — no Bearer token storage in JS-accessible storage.
const api = axios.create({ baseURL: API, withCredentials: true });

const MUTATING_METHODS = new Set(["post", "put", "patch", "delete"]);

export function readCsrfToken() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|; )csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

// Double-submit CSRF: echo the csrf_token cookie back in a header on mutating
// requests. Bootstrap auth endpoints (login/register/refresh) are exempted
// server-side and will MINT the token in their response cookies.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (!MUTATING_METHODS.has(method)) return config;
  const token = readCsrfToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

export default api;
